import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../lib/firebase';
import { isLoginFlowBlockingRedirect } from '../services/authService';
import { resolvePostLoginLandingPage } from '../utils/trialDemarrageRedirect';

interface AuthRedirectProps {
  children: React.ReactNode;
}

/**
 * Composant qui redirige les utilisateurs déjà connectés vers le dashboard
 * lorsqu'ils tentent d'accéder à des pages publiques comme la page de connexion
 */
export const AuthRedirect: React.FC<AuthRedirectProps> = ({ children }) => {
  const { user } = useAuth();
  const navigate = useNavigate();

  // console.log supprimé

  useEffect(() => {
    // Ne pas rediriger pendant un flux login / 2FA en cours (évite la boucle login → dashboard → login)
    if (user && !isLoginFlowBlockingRedirect()) {
      // console.log supprimé
      // Récupérer la préférence de page d'arrivée directement depuis Firestore
      const getLandingPage = async () => {
        let preferredLandingPage = '/dashboard';
        try {
          const userPrefsDoc = await getDoc(doc(db, 'userPreferences', user.uid));
          if (userPrefsDoc.exists()) {
            const userPrefs = userPrefsDoc.data();
            if (userPrefs.defaultLandingPage) {
              preferredLandingPage = userPrefs.defaultLandingPage;
            }
          }
        } catch {
          // En cas d'erreur, utiliser la valeur par défaut
        }

        const landingPage = await resolvePostLoginLandingPage(user.uid, preferredLandingPage);
        navigate(landingPage, { replace: true });
      };
      getLandingPage();
    }
  }, [user, navigate]);

  // Afficher le formulaire si non connecté ou si un flux 2FA est en cours
  if (!user || isLoginFlowBlockingRedirect()) {
    // console.log supprimé
    return <>{children}</>;
  }

  // Pendant la redirection, afficher un écran de chargement minimal
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-950">
      <div className="animate-pulse text-brand-primary">Redirection...</div>
    </div>
  );
};

export default AuthRedirect;
